<script setup lang="ts">
import type { Schemas } from "#shopware";

const props = defineProps<{
  product: Schemas["Product"];
}>();
const { product } = toRefs(props);

const { unitPrice, displayFromVariants, displayFrom, price, isListPrice } =
  useProductPrice(product);

const discountPrice = computed(() =>
  isListPrice.value && price.value?.listPrice?.price > unitPrice.value
    ? Math.round(price.value?.listPrice?.price - unitPrice.value)
    : 0
);
</script>

<template>
  <div class="flex flex-col" :id="product.id">
    <div>
      <SharedPrice
        v-if="displayFromVariants"
        :value="displayFromVariants"
        classes="text-md md:text-lg font-bold text-purple"
      >
      </SharedPrice>
      <span v-if="displayFromVariants"> - </span>
      <template v-if="isListPrice && price?.listPrice?.price && unitPrice && price?.listPrice?.price > unitPrice">
        <span class="text-sm text-gray-700 ml-2 opacity-80 mr-1"> {{ $t("product.price.previously") }} </span>
        <SharedPrice
          classes="text-sm text-gray-700 line-through opacity-80"
          :value="price?.listPrice?.price"
        />
      </template>
      <SharedPrice
        v-if="isListPrice && discountPrice > 0"
        class="text-sm font-medium ml-2 text-red"
        :value="discountPrice"
      >
        <template #beforePrice><span>-</span></template>
      </SharedPrice>
    </div>
    <div>
      <SharedPrice
        :value="unitPrice"
        classes="text-md md:text-lg font-bold text-purple"
        :class="{'text-red': isListPrice && discountPrice > 0}"
      >
      </SharedPrice>
    </div>
  </div>
</template>
